import React from 'react'

function ContactHeader() {
  return (
    <div className="heading heading-about">
      <div>
        <h2>#let's_talk</h2>
        <p>LEAVE A MESSAGE. We love to hear from you!</p>
      </div>
    </div>
  );
}

export default ContactHeader